import { render, staticRenderFns } from "./AddDB.vue?vue&type=template&id=4c8b45b2&scoped=true&"
import script from "./AddDB.vue?vue&type=script&lang=js&"
export * from "./AddDB.vue?vue&type=script&lang=js&"
import style0 from "./AddDB.vue?vue&type=style&index=0&id=4c8b45b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b45b2",
  null
  
)

export default component.exports